import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

// Minimal cookie banner. Surfaces the fact that the platform uses
// strictly-necessary cookies (session + security) and gives the visitor a
// single "got it" acknowledgement. We don't set any non-essential
// cookies today, so the banner is an acknowledgement rather than a true
// preference prompt — if analytics or marketing cookies are added later
// this component should expand to an accept/reject split.

const STORAGE_KEY = "exambase:cookie-consent:v1";

export function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch {
      // localStorage disabled (private mode) — don't pop the banner
      // since we can't remember the dismissal anyway.
    }
  }, []);

  if (!open) return null;

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setOpen(false);
  }

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border/60 bg-background/95 p-4 backdrop-blur"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 text-sm sm:flex-row sm:items-center sm:justify-between">
        <p className="max-w-3xl">
          ExamBase uses strictly-necessary cookies for sign-in and security
          (including Cloudflare Turnstile to block automated attacks). We
          don't use analytics or marketing cookies. See the{" "}
          <a
            href="/accessibility"
            className="underline underline-offset-2 hover:text-foreground"
          >
            accessibility statement
          </a>{" "}
          for how to contact us.
        </p>
        <Button onClick={dismiss} className="shrink-0 self-start sm:self-auto">
          Got it
        </Button>
      </div>
    </div>
  );
}
